import moment from "moment";
import React, { useState, useEffect } from "react";
import { FREE_TRIAL_PROMO_CODES } from "../constants/freeTrialPromocodes";
import { applyDiscount } from "../utils/plans";
import {
  listOfSubscriptionNames,
  plansEnvConfig,
} from "../../../common/envConfig";

const SubscriptionDetails = ({
  freeTrial,
  coupon,
  discount,
  discountType,
  showFreeTrialMessage,
  subscriptionAmount,
  productId,
}) => {
  const getPaymentDate = () => {
    if (freeTrial && freeTrial === 14) {
      return moment().add(2, "weeks").format("MM/DD/YYYY");
    }
    if (FREE_TRIAL_PROMO_CODES.includes(coupon) && showFreeTrialMessage) {
      return moment().add(31, "days").format("MM/DD/YYYY");
    }
    return moment().format("MM/DD/YYYY");
  };

  return (
    <div className="mb-6 rounded-2xl border border-gray200 bg-white p-6 shadow-md">
      {FREE_TRIAL_PROMO_CODES.includes(coupon) && showFreeTrialMessage && (
        <p className="mb-4 text-center text-lg font-bold">
          You will not be charged for the first {freeTrial} days and you may
          cancel anytime.
        </p>
      )}

      <div className="mb-3 grid grid-cols-2">
        <span className="font-bold">Plan:</span>
        <span className="text-right">{listOfSubscriptionNames[productId]}</span>
      </div>

      <div className="mb-3 grid grid-cols-2">
        <span className="font-bold">Amount:</span>
        <span className="text-right">
          $
          {subscriptionAmount > -1
            ? subscriptionAmount
            : applyDiscount({
                discount: discount,
                price: Number(plansEnvConfig[productId]) || 0,
                type: discountType,
              })}
        </span>
      </div>

      <div className="mb-3 grid grid-cols-2">
        <span className="font-bold">Billed:</span>
        <span className="text-right">
          {productId.includes("monthly") ? "MONTHLY" : "ANNUALLY"}
        </span>
      </div>

      <div className="grid grid-cols-2">
        <span className="font-bold">Payment Date:</span>
        <div className="text-right">
          <p>{getPaymentDate()}</p>
          <p className="mt-1 text-xs text-gray-600">
            Plan automatically renews until canceled. Cancel at least a day
            before the renewal date.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionDetails;
